import { useNavigate } from 'react-router-dom';

import { ErrorIndicator } from '@components/ErrorIndicator';
import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { Broadband as BroadbandUi } from '@features/Broadband';
import { useBundleBasket } from '@hooks/useBundleBasket';
import { useDetectMidJourneyLogin } from '@hooks/useDetectMidJourneyLogin';
import { usePageStateHandler } from '@hooks/usePageStateHandler';
import { withProfiler } from '@services/sentry/withProfiler';
import { BundleBasketData } from '@src/types/bundle';

const PAGE_TITLE = 'Broadband';

const BroadbandUnwrapped = () => {
  const navigate = useNavigate();
  const { error, basket, loading, selectedServices, basketData } =
    useBundleBasket({});

  useDetectMidJourneyLogin({ basketData, loading });
  const { isLoading, hasError } = usePageStateHandler({
    loading,
    hasData: !!basket,
    error,
  });

  if (isLoading) {
    return null;
  }

  if (hasError) {
    return (
      <Layout
        title={PAGE_TITLE}
        backButtonLabel="Back to bundle"
        onBack={() => navigate(paths.bundle)}
      >
        <ErrorIndicator />
      </Layout>
    );
  }

  return (
    <Layout
      title={PAGE_TITLE}
      backButtonLabel="Back to bundle"
      onBack={() => navigate(paths.bundle)}
    >
      <BroadbandUi
        basket={basket as BundleBasketData}
        selectedServices={selectedServices}
      />
    </Layout>
  );
};

const Broadband = withProfiler(BroadbandUnwrapped);
export { Broadband };
